<button id="table.id" type="button" class="btn btn-icon btn-outline-primary mx-1" placement="bottom"
    ngbTooltip="{{'Create' | translate}}">
    <span class=" tf-icons bx bx-plus"></span>
</button>